import toast from "react-hot-toast";

export const alertType = {
  success: "success",
  error: "error",
};

export const appToast = (alertType, msg) =>
  toast[alertType]("Here is your toast.");

export const successToast = (msg) => toast.success(msg);
export const errorToast = (msg) => toast.error(msg);
